import React, { useState } from 'react';

import { api } from '../../core/services';
import { SpecificationItem } from '../../components';

const getCurrencyName = name => {
  switch (name) {
    case 'price_gbp': return 'gbp';
    case 'price_euro': return 'eur';
    default: return null;
  }
};

function formatDate(date) {
  if (!date) return null
  date = new Date(date)
  let dd = date.getDate();
  if (dd < 10) dd = '0' + dd;

  let mm = date.getMonth() + 1;
  if (mm < 10) mm = '0' + mm;

  const yy = date.getFullYear() ;

  return dd + '/' + mm + '/' + yy;
}

const getExtra = (name, product) => {
  if (name === 'price_euro') {
    return (product.values?.price_euro_date) ? <span> - ${formatDate(product?.values?.price_euro_date?.value)
    }</span>: '';
  } else if (name === 'price_gbp') {
    return (product.values?.price_gbp_date) ? <span className={'data-points'}> - {formatDate(product?.values?.price_gbp_date?.value)
    }</span> : '';
  } else {
    return null;
  }
};

const ProductValue = ({
  label,
  value: data,
  name,
  product,
  isEditing = false,
}) => {
  const [value, setValue] = useState(data || product?.values?.[name]?.value)

  if (!isEditing || !name) {
    return (
      <SpecificationItem {...{
        label,
        value,
        currency: getCurrencyName(name),
        extra: getExtra(name, product),
      }} />
    );
  }

  const handleChange = (val) => {
    if (['price_euro', 'price_gbp'].includes(name) && !isNaN(parseInt(val))) {
      setValue(parseInt(val) * 100);
    } else {
      setValue(val);
    }
  }

  const handleSubmit = async (submitValue) => {
    const productValue = product?.values?.[name];

    if (!submitValue && !productValue?.id) {
      return;
    }

    let url = `/api/products/${product?.id}/product-values`;
    let method = 'put';
    let body = {
      value: ['price_euro', 'price_gbp'].includes(name) && !isNaN(parseInt(submitValue)) ?
        parseInt(submitValue) * 100 :
        submitValue,
    };

    if (productValue?.id) {
      url += `/${productValue?.id}`;
    } else {
      method = 'post';
      body.field_name = name;
    }

    try {
      const updateProductValue = await api[method](url, body);
      product.values[name] = updateProductValue;
    } catch (error) {
      setValue(productValue?.value || '');
    }
  };

  const inputValue = ['price_euro', 'price_gbp'].includes(name) && !isNaN(parseInt(value)) ?
    parseInt(value) / 100 :
    value;

  const input = (
    <input
      onChange={e => handleChange(e.target.value)}
      onBlur={(e) => handleSubmit(e.target.value)}
      value={inputValue || ''}
      className="product-value-inline-input"
      type="text"
    />
  );

  return (
    <SpecificationItem
      {...{
        label,
        value: input,
      }}
    />
  );
}

export default ProductValue;
